import type { Ref } from 'react';
import { Link } from 'react-router-dom';
import {
  IconButtonLink as LiquidityIconButtonLink,
  type IconButtonLinkProps as LiquidityIconButtonLinkProps,
} from '@c2fo/liquidity';

interface IconButtonLinkProps extends Omit<LiquidityIconButtonLinkProps<typeof Link>, 'as' | 'ref'> {
  to: string;
  ref?: Ref<HTMLAnchorElement>;
}

export function IconButtonLink({ ref, ...props }: IconButtonLinkProps) {
  return <LiquidityIconButtonLink {...props} ref={ref} as={Link} />;
}
